module.exports = __webpack_public_path__ + "6c60c10f8df91a29cac2fb33f8f7d2bd.png";